module.exports = "img/1.d24dc2.webp";